import '@/plugins/axios'
import { getBaseUrl, getParameter } from '@/utils/endpoint'

export function getData(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/selfsalesorder', { params: new_params })
}

export function getDataDetail(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/selfsalesorder/' + id, { params: new_params })
}

export function cancelOrder(id, data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.put(getBaseUrl() + '/selfsalesorder/cancelledorder/' + id, data, { params: new_params })
}

export function createOrder(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/selfsalesorder/openorder', data, { params: new_params })
}

export function payOrder(id, data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/payorder/' + id, data, { params: new_params })
}

export function hitDiscount(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/discount/hit', data, { params: new_params })
}

export function getDataShipping(params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/shipping/list', { params: new_params })
}

export function getDataShippingV2(data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/shipping/v2/list', data, { params: new_params })
}

export function createChat(id, data, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.post(getBaseUrl() + '/chat/' + id, data, { params: new_params })
}

export function getChat(id, params = {}) {
  const new_params = { ...getParameter(), ...params }
  return window.axios.get(getBaseUrl() + '/chat/' + id, { params: new_params })
}
